// Modal.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const ModalComponent = ({
  title,
  subTitle,
  content,
  isOpen,
  onClose,
  children,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            className="modal-container"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ type: "spring", damping: 20, stiffness: 700 }}
          >
            <div className="modal-content">
              <div className="modal-header d-flex flex-row justify-content-between align-items-center">
                <div>
                  <h2>{title}</h2>
                  <h3>{subTitle}</h3>
                </div>
                <button className="modalClose" onClick={onClose}>
                  <i className="far fa-times-circle font-20 color-dark-4"></i>
                </button>
              </div>

              {children ? (
                <div className="modal-body">{children}</div>
              ) : (
                <>
                  <div className="modal-body">{content}</div>

                  <div className="modal-footer">
                    <button className="close-button" onClick={onClose}>
                      Close
                    </button>
                  </div>
                </>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ModalComponent;
